import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ShopSettingsService } from '../../modules/general/services/shop-settings.service';
import { environment } from '../../../environments/environment';
import { OrderStateService } from '../../modules/order/services/order-state.service';
declare let fbq: Function;

@Component({
  selector: 'app-page-thank-you',
  templateUrl: './page-thank-you.component.html',
  styleUrls: ['./page-thank-you.component.css']
})
export class PageThankYouComponent implements OnInit {

  constructor(
    private router: Router,
    private shopSettingsService: ShopSettingsService,
    private orderStateService: OrderStateService,
  ) { }

  ngOnInit(): void {
    if (this.shopSettingsService.facebookAnalyticsId) {
      const location = environment.odooDatabaseName;
      fbq('track', 'CompleteRegistration', {
        'location': location
      });
    }

    this.orderStateService.orderRemoveFromLocalStore();

    setTimeout(
      () => {
        this.router.navigate(['']);
      },
      5000);
  }

}
